class SystemsightAjaxFormHandler {
    constructor(options) {
        let defaults = {
                version: '1.0.2',
                formSelector: '[data-type="ajax"]',
                submitSelector: 'button[type="submit"]',
                preloaderElement: ' <div class="preloader spinner-border spinner-border-sm" role="status"><span class="sr-only">...</span></div>'
        };
        this.options = $.extend(true, {}, defaults, (options || {}));

        this.init();
    }
    init(){
        let that = this;
        //start listening for submits
        $('body').on('submit', this.options.formSelector, function (e, data) {
            let $button = $(this).data('submit_invoker');
            that.handle_form_submit($(this), $button, data);
            $(this).data('submit_invoker', null);
            return false;
        }).on('click', this.options.formSelector + ' button[type="submit"]',function (e) {
            //sets submit action invoker
            $(this.form).data('submit_invoker', $(this));
        });

        console.log('SystemsightAjaxFormHandler inited (' + this.options.version + ')');
    }

    find_submit_btn($form, $button = null){
        var that = this;
        if(!$button){
            $button = $form.find(that.options.submitSelector);
        }
        return $button;
    }

    handle_form_submit($form, $button = null, extraData = null) {
        var that = this;
        that.show_preloader($form, $button);

        var formData = $form.serializeArray();

        if($button && $button.attr('name')){
            formData.push(
                {
                    name: $button.attr('name'),
                    value: $button.val()
                }
            );
        }

        if(extraData){
            for (var k in extraData){
                formData.push(
                    {
                        name: k,
                        value: extraData[k]
                    }
                );
            }
        }

        $form.trigger('before-submit', formData);
        $.post($form.attr('action'), formData).done(function (r) {
            $form.trigger('after-submit', r);
            that.handle_form_submit_done($form, r);
        }).always(function (e) {
            that.hide_preloader($form, $button);
            that.handle_form_submit_always($form);
        }).fail(function (e) {
            $form.trigger('submit-fail');
            that.handle_form_submit_fail($form, e);
        })
        ;
    };

    show_preloader($form, $button) {
        var that = this;
        $button = that.find_submit_btn($form, $button);

        if($button.find('.preloader').length === 0){
            $button.append(that.options.preloaderElement);
        }
        $form.find(that.options.submitSelector)
            .attr("disabled", "disabled");

        $button.find('.preloader').removeClass('d-none')
        ;
    };
    hide_preloader($form, $button) {
        var that = this;
        $button = that.find_submit_btn($form, $button);
        $form.find(that.options.submitSelector)
            .attr("disabled", null)
            .find('.preloader').addClass('d-none')
        ;
    };
    remove_form_feedbacks($form) {
        var that = this;
        console.log('remove_form_feedbacks');
        $form.find('input,select,textarea')
            .removeClass('is-invalid is-valid')
            .parents('.form-group').find('.invalid-feedback').html('').removeClass('d-block')
        ;
    };
    handle_form_submit_always($form) {
        var that = this;
        //reload captcha
        $form.find('.captcha-c').each(function () {
            $(this).find('input').val('');
            $(this).data('refresh')();
        })
        //update fancybox
        if($form.parents('.fancybox-wrap').length){
            $.fancybox.update()
        }
    }
    handle_form_submit_fail($form, event) {
        var that = this;
        that.display_messages($form, {
            message: {
                type: 'danger',
                text: event.status + " " + event.statusText
            }
        });
    };
    handle_form_submit_done($form, response) {
        var that = this;

        that.remove_form_feedbacks($form);

        if(response.status == "ok"){
        }else{
            for(var fieldName in response.errors){
                var $field = $form.find('[name="'+fieldName+'"],[name="'+fieldName+'[]"],[data-input_name="'+fieldName+'"]');
                $field.addClass('is-invalid').parents('.form-group').find('.invalid-feedback')
                    .html(response.errors[fieldName])
                    .addClass('d-block')
                ;
            }
        }

        if(typeof response.transformed_data === 'object'){
            for(var fieldName in response.transformed_data){
                var $field = $form.find('[name="'+fieldName+'"],[data-input_name="'+fieldName+'"]');
                //todo: check radio or checkbox types
                $field.val(response.transformed_data[fieldName]);
            }
        }


        if(typeof response.callback === 'string'){
            that.eval_callback(response.callback, response.nonce || 'nonce');

        }

        if(typeof response.redirect === "string"){
            window.location.href = response.redirect;
        }

        if(typeof response.message !== 'undefined'){
            that.display_messages($form, response);
        }

        if(typeof response.modal === 'string'){
            that.display_modal($form, response.modal);
        }

        if(typeof response.modal_body === 'string'){
            that.display_modal(
                $form,
                that.get_modal_html(response.modal_body)
            );
        }

        if(typeof response.replace_with === "string"){
            var $r = $(response.replace_with);

            if(response.target){
                $(response.target).replaceWith($r);
            }else{
                $form.replaceWith($r);
                $form = $r;
            }

        }
    };
    eval_callback(evalValue, nonce) {
        var $script = $('<script nonce="' + nonce + '">' + evalValue + '</script>')
        $('body').append($script)
        $script.remove();
    }
    display_modal($form, modal){
        var $modal = $(modal);
        $('body').append($modal);
        $modal.modal({}).on('hidden.bs.modal', function (e) {
            $modal.remove();
        })
    };
    display_messages($form, response){
        var that = this;
        var modalBody = '';
        if(typeof response.message == "object"){
            if(Array.isArray(response.message )){
                if(response.message.length){
                    $.each(response.message, function (index, msg) {
                        if(typeof msg == "object"){
                            modalBody += '<div class="alert alert-'+msg.type+'">'+msg.text+'</div>';
                        }else{
                            modalBody += '<div class="alert alert-info">'+msg+'</div>';
                        }
                    })
                }

            }else{
                modalBody += '<div class="alert alert-'+response.message.type+'">'+response.message.text+'</div>';
            }
        }else{
            modalBody += '<div class="alert alert-info">'+response.message+'</div>';
        }

        if(modalBody){
            that.display_modal($form, that.get_modal_html(modalBody));
        }
    }

    get_modal_html(modalBody) {
        var that = this;
        var modalHtml =
            '<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">'
            + '<div class="modal-dialog" role="document">'
            + '<div class="modal-content">'
            + '<div class="modal-header">'
            + '<h5 class="modal-title" id="exampleModalLabel">&nbsp;</h5>'
            + '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
            + '</div>'
            + '<div class="modal-body">'+modalBody+'</div>'
            + '</div>'
            + '</div>'
            + '</div>'
        ;

        return modalHtml;
    };
}

var systemsightAjaxFormHandler = new  SystemsightAjaxFormHandler();

export default systemsightAjaxFormHandler;